import React from 'react';

import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { isEmpty } from 'lodash';

import ReceiptTear from 'assets/images/receipt-tear.png';
import { Button } from 'modules/common/input';
import { formatCurrency, print } from 'modules/common/utils';

import CartRowV2, { CartRowHeader } from '../cart/CartRowV2';
import PrintTemplateV2 from './PrintTemplateV2';

function PrintReceiptV2({
  includes,
  branch,
  state,
  settings,
  onGoBack,
  onParentClose,
}) {
  const locState = useLocation()?.state || {};

  const { res, payment_method, amount_tendered, change } = isEmpty(state)
    ? locState
    : state;

  const handleOnPrint = () => {
    print('print-template');
  };

  return (
    <div className="flex flex-col flex-1 items-center md:mt-7 p-3 md:p-5 overflow-y-auto overflow-x-hidden">
      <div className="hidden" id="print-template">
        <PrintTemplateV2
          businessName={branch?.business_name}
          branchName={branch?.branch_name}
          businessLogo={branch?.logo_url}
          address={branch?.address_details || branch?.address?.address_details}
          cart={res?.cart}
          includes={includes}
          paymentMethod={payment_method}
          amountTendered={amount_tendered}
          change={change}
          data={{
            subtotal: settings?.data?.subtotal_human,
            discount: `- ${
              settings?.discountIncluded?.hasSelectedDiscount
                ? formatCurrency(settings?.discountValue || 0)
                : formatCurrency(0)
            }`,
            chargesList: settings?.chargesList,
            totalVAT: settings?.totalVAT,
            VAT: formatCurrency(settings?.VAT || 0) || '-',
            total: formatCurrency(settings?.getTotal || 0),
          }}
        />
      </div>
      <div className="flex flex-col w-full max-w-[400px] space-y-3 py-5">
        <div className="w-full flex flex-col">
          <img src={ReceiptTear} alt="" className="h-9 w-full" />
          <div className="flex flex-col p-10 pt-5 pb-5 space-y-5 border bg-white border-t-0 border-b-0">
            <div className="space-y-1.5 flex flex-col">
              <div className="font-bold text-lg flex flex-wrap justify-center gap-1 text-center">
                <div>{branch?.business_name} </div>
                <div className="text-primary-500">
                  {branch?.branch_name && `- ${branch?.branch_name}`}
                </div>
              </div>
              <div className="text-xs text-gray-500 text-center">
                {branch?.address_details || branch?.address?.address_details}
              </div>
            </div>

            <div className="border-t pt-5 border-dashed space-y-3 overflow-hidden">
              <CartRowHeader withRemove={false} />

              <div className="space-y-1.5 overflow-y-auto max-h-52 pt-1.5 pr-1">
                {settings?.data?.products?.length > 0 ? (
                  settings?.data?.products?.map((item, key) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <CartRowV2 value={item} key={key} withImage={false} />
                  ))
                ) : (
                  <div className="text-gray-400 text-xs text-center py-4">
                    <i>No items in this order...</i>
                  </div>
                )}
              </div>
            </div>

            <div className="space-y-3">
              <hr />

              <div className="space-y-1 text-sm py-0">
                <div className="flex items-center justify-between">
                  <div>Subtotal</div>
                  <div>{settings?.data?.subtotal_human}</div>
                </div>
                <div className="flex items-center justify-between">
                  <div>Discount</div>
                  <div>
                    -{' '}
                    {settings?.discountIncluded?.hasSelectedDiscount
                      ? formatCurrency(settings?.discountValue || 0)
                      : formatCurrency(0)}
                  </div>
                </div>
              </div>

              <hr />

              <div className="space-y-1 text-sm py-0">
                {settings?.chargesList?.map((item) => (
                  <div className="flex items-center justify-between">
                    <div>{item?.name}</div>
                    <div>{formatCurrency(item?.value || 0) || '-'}</div>
                  </div>
                ))}

                <div className="flex items-center justify-between">
                  <div>VAT ({settings?.totalVAT}%)</div>
                  <div>{formatCurrency(settings?.VAT || 0) || '-'}</div>
                </div>
              </div>

              <hr />

              <div className="space-y-1 text-sm py-0">
                <div className="flex items-center justify-between">
                  <div>Total</div>
                  <div className="font-bold">
                    {formatCurrency(settings?.getTotal || 0)}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img src={ReceiptTear} alt="" className="h-9 w-full rotate-180" />
        </div>

        <div className="flex items-center gap-2 mx-auto pt-2">
          <Button
            label="Go Back"
            className="btn gray bg-gray-100 font-semibold"
            onClick={() => {
              onGoBack();
              onParentClose();
            }}
          />
          <Button
            label="Print Receipt"
            className="btn primary font-semibold"
            onClick={handleOnPrint}
          />
        </div>
      </div>
    </div>
  );
}

PrintReceiptV2.defaultProps = {
  includes: {},
  branch: {},
  state: {},
  settings: {},
  onGoBack: () => {},
  onParentClose: () => {},
};

PrintReceiptV2.propTypes = {
  onGoBack: PropTypes.instanceOf(Function),
  onParentClose: PropTypes.instanceOf(Function),
  includes: PropTypes.instanceOf(Object),
  settings: PropTypes.instanceOf(Object),
  branch: PropTypes.instanceOf(Object),
  state: PropTypes.instanceOf(Object),
};

export default PrintReceiptV2;
